const WhatsAppFloat = () => {
  return (
    <a
      href="https://wa.me/971562022818"
      target="_blank"
      rel="noopener noreferrer"
      className="fixed bottom-6 right-6 z-50 w-14 h-14 bg-[#25D366] rounded-full flex items-center justify-center shadow-lg hover:scale-110 transition-transform cursor-pointer group"
      aria-label="Chat on WhatsApp"
    >
      <i className="ri-whatsapp-fill text-white text-3xl"></i>
      <span className="absolute right-16 bg-jet-black text-white px-4 py-2 rounded-lg text-sm font-medium whitespace-nowrap opacity-0 group-hover:opacity-100 transition-opacity pointer-events-none">
        Need Help? Chat with us!
      </span>
    </a>
  );
};

export default WhatsAppFloat;
